<template>
  <div class="">
    <div class="controlBox bg-l-black">
      <div class="controlHeader">
        <div class="title">数据汇总</div>
        <div class="control">
          <div>
            <a-month-picker
              :allowClear="false"
              :value="month"
              v-if="selectDate === 2"
              class="ml15"
              style="width: 200px !important; display: inline-block"
              v-model="month"
              :format="monthFormat"
              @change="onChange1"
            />
            <a-date-picker
              :allowClear="false"
              :value="date"
              v-else-if="selectDate === 0"
              class="ml15"
              style="width: 200px !important; display: inline-block"
              v-model="date"
              :format="dateFormat"
              @change="onChange2"
            />
            <a-week-picker
              :allowClear="false"
              v-else
              :value="week"
              v-model="week"
              format="YYYY年-第wo"
              class="ml15"
              style="width: 200px !important; display: inline-block"
              @change="onChange"
            />
          </div>
          <!-- <a-button
          type="primary"
          class="addBtn"
          @click="operation('add')"
          v-if="userType != 4 && userType != 5"
          >发布总结</a-button
        > -->
          <div class="tab">
            <div
              :class="selectDate == 2 ? 'active' : ''"
              @click="changeData(2)"
            >
              月
            </div>
            <div
              :class="selectDate == 1 ? 'active' : ''"
              @click="changeData(1)"
            >
              周
            </div>
            <div
              :class="selectDate == 0 ? 'active' : ''"
              @click="changeData(0)"
            >
              日
            </div>
          </div>
        </div>
      </div>

      <!------------ 切换的内容区域-start ------------>

      <!-- 日-start -->
      <div class="tabCon day" v-if="selectDate == 0">
        <!-- <a-table
          :dataSource="dataSource"
          :columns="columns"
          :pagination="false"
        >
          <template #drillTimeFrame="{ record }">
            <span v-if="record.drillTimeFrame == 1">早操</span>
            <span v-if="record.drillTimeFrame == 2">上午</span>
            <span v-if="record.drillTimeFrame == 3">下午</span>
            <span v-if="record.drillTimeFrame == 4">晚上</span>
            <span v-if="record.drillTimeFrame == 5">全天</span>
          </template>
          <template #fatigue="{ record }">
            {{ record.fatigue + "级" }}
          </template>
          <template #remark="{ record }">
            <div class="elpss2">
              {{ record.remark }}
            </div>
          </template>
          <template v-slot:tags="tags">
            <a-button
              type="primary"
              @click="operation('edit', tags.record)"
              v-if="tags.record.editAndDelStatus == 1"
              >编辑</a-button
            >
            <a-popconfirm
              title="确定删除吗？该操作不会撤销"
              ok-text="是"
              cancel-text="否"
              @confirm="sumDele('delete', tags.record)"
              v-if="tags.record.editAndDelStatus == 1"
            >
              <a-button type="primary" danger> 删除 </a-button>
            </a-popconfirm>
          </template>
        </a-table> -->

        <el-table
          element-loading-text="加载中"
          :data="dataSource"
          border
          style="width: 100%"
        >
          <el-table-column label="时段" align="center" prop="drillTimeFrame">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.drillTimeFrame == 1">早操</span>
                <span v-if="scope.row.drillTimeFrame == 2">上午</span>
                <span v-if="scope.row.drillTimeFrame == 3">下午</span>
                <span v-if="scope.row.drillTimeFrame == 4">晚上</span>
                <span v-if="scope.row.drillTimeFrame == 5">全天</span>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            label="训练日期"
            align="center"
            prop="trainingTime"
            width="180"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.trainingTime
                    ? moment(scope.row.trainingTime).format(
                        "yyyy-MM-DD HH:mm:ss",
                      )
                    : ""
                }}
              </div>
            </template>
          </el-table-column> -->

          <el-table-column
            label="训练完成情况"
            align="center"
            prop="drillPerformance"
            width="150"
          >
          </el-table-column>

          <el-table-column
            label="总结说明"
            align="center"
            prop="remark"
            width="600"
          >
          </el-table-column>
          <el-table-column
            label="主观疲劳感(1-10级)"
            align="center"
            prop="fatigue"
            width="170"
          >
          </el-table-column>
          <el-table-column
            label="总结人"
            align="center"
            prop="createBy"
            width="170"
          >
          </el-table-column>
          <el-table-column
            label="总结时间"
            align="center"
            prop="createTime"
            width="180"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.createTime
                    ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss")
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <div class="">
                <el-button
                  size="small"
                  plain
                  type="primary"
                  @click="operation('edit', scope.row)"
                  v-if="scope.row.editAndDelStatus == 1"
                  >详情</el-button
                >

                <a-popconfirm
                  title="确定删除吗？该操作不会撤销"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="sumDele('delete', scope.row)"
                  v-if="scope.row.editAndDelStatus == 1"
                >
                  <el-button size="small" plain type="danger">删除</el-button>
                </a-popconfirm>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <!-- 日-end -->

      <!-- 周-start -->
      <div class="tabCon week" v-if="selectDate == 1 || selectDate == 2">
        <!-- 完成情况 -->
        <div class="box complete">
          <!-- <div class="minTitle">完成情况</div>
          <div class="minTitleInfo">
            <span
              >本{{ selectDate == 1 ? "周" : "月" }}共计划训练
              <b>{{ data_wcqk.drillNum }}</b> 次，进行了
              <b>{{ data_wcqk.summaryNum }}</b> 次总结</span
            >
          </div>
          <div class="list">
            <div class="block">
              <p>已完成(次)</p>
              <strong>{{ data_wcqk.doneNum }}</strong>
            </div>
            <div class="block">
              <p>未完成(次)</p>
              <strong>{{ data_wcqk.undoneNum }}</strong>
            </div>
            <div class="block">
              <p>较好完成(次)</p>
              <strong>{{ data_wcqk.betterFinishNum }}</strong>
            </div>
            <div class="block">
              <p>较差完成(次)</p>
              <strong>{{ data_wcqk.inferiorFinishNum }}</strong>
            </div>
          </div> -->

          <el-card class="boxCard">
            <div class="minTitle">完成情况</div>
            <div class="minTitleInfo">
              <span
                >本{{ selectDate == 1 ? "周" : "月" }}共计划训练
                <b style="color: #ffa94c">{{ data_wcqk.drillNum }}</b>
                次，进行了
                <b style="color: #ffa94c">{{ data_wcqk.summaryNum }}</b>
                次总结</span
              >
            </div>
            <div class="list">
              <div class="item">
                <div class="count">已完成(次)</div>
                <div class="num">{{ data_wcqk.doneNum }}</div>
              </div>
              <div class="item">
                <div class="count">未完成(次)</div>
                <div class="num">{{ data_wcqk.undoneNum }}</div>
              </div>
              <div class="item">
                <div class="count">较好完成(次)</div>
                <div class="num">{{ data_wcqk.betterFinishNum }}</div>
              </div>
              <div class="item">
                <div class="count">较差完成(次)</div>
                <div class="num">{{ data_wcqk.inferiorFinishNum }}</div>
              </div>
            </div>
          </el-card>
        </div>

        <!-- 运动员总结主观疲劳感 -->
        <!-- <div class="box chart">
          <div class="minTitle">运动员总结主观疲劳感(1-10)</div>
          <div class="minTitleInfo">
            <span
              >最大疲劳感 <b>{{ data_ydyzj.maxValue || "" }}</b> 级</span
            >
            <span
              >最小疲劳感 <b>{{ data_ydyzj.minValue || "" }}</b> 级</span
            >
          </div>
          <div id="echartsDom1" class="figure"></div>
        </div> -->

        <!-- 教练员总结主观疲劳感 -->
        <!-- <div class="box chart">
          <div class="minTitle">教练员总结主观疲劳感(1-10)</div>
          <div class="minTitleInfo">
            <span
              >最大疲劳感 <b>{{ data_jlyzj.maxValue || "" }}</b> 级</span
            >
            <span
              >最小疲劳感 <b>{{ data_jlyzj.minValue || "" }}</b> 级</span
            >
          </div>
          <div id="echartsDom2" class="figure"></div>
        </div> -->

        <div class="box">
          <el-card class="boxCard">
            <!-- 运动员总结主观疲劳感 -->
            <div class="chart">
              <div class="minTitle">运动员总结主观疲劳感(1-10)</div>
              <div class="minTitleInfo">
                <span
                  >最大疲劳感 <b>{{ data_ydyzj.maxValue || "" }}</b> 级</span
                >
                <span
                  >最小疲劳感 <b>{{ data_ydyzj.minValue || "" }}</b> 级</span
                >
              </div>
              <div id="echartsDom1" class="figure"></div>
            </div>
            <!-- 教练员总结主观疲劳感 -->
            <div class="chart">
              <div class="minTitle">教练员总结主观疲劳感(1-10)</div>
              <div class="minTitleInfo">
                <span
                  >最大疲劳感 <b>{{ data_jlyzj.maxValue || "" }}</b> 级</span
                >
                <span
                  >最小疲劳感 <b>{{ data_jlyzj.minValue || "" }}</b> 级</span
                >
              </div>
              <div id="echartsDom2" class="figure"></div>
            </div>
          </el-card>
        </div>

        <!-- 全天总结说明 -->
        <!-- <div class="box chart">
          <div class="minTitle">全天总结说明</div>
          <a-table
            :dataSource="data_zjsm"
            :columns="columns_zjsm"
            :pagination="false"
          >
            <template #fatigue="{ record }">
              {{ record.fatigue + "级" }}
            </template>
            <template #remark="{ record }">
              <div class="elpss2">
                {{ record.remark }}
              </div>
            </template>
            <template v-slot:tags="tags">
              <div v-if="tags.record.editAndDelStatus == 1">
                <a-button type="primary" @click="operation('edit', tags.record)"
                  >编辑</a-button
                >
                <a-popconfirm
                  title="确定删除吗？该操作不会撤销"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="sumDele('delete', tags.record)"
                >
                  <a-button type="primary" danger> 删除 </a-button>
                </a-popconfirm>
              </div>
            </template>
          </a-table>
          <div class="yf-pagination wz-flex-row wz-justify-end">
            <a-pagination
              show-quick-jumper
              v-model:pageSize="pageSize"
              v-model:current="pageNum"
              :total="total_zjsm"
              @change="changePage"
            />
          </div>
        </div> -->

        <!-- 全天总结说明 -->
        <div class="box">
          <el-card class="boxCard">
            <el-table
              element-loading-text="加载中"
              :data="data_zjsm"
              @selection-change="handleSelectionChange"
              border
              style="width: 100%"
            >
              <el-table-column
                label="训练日期"
                align="center"
                prop="trainingTime"
                width="180"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.trainingTime
                        ? moment(scope.row.trainingTime).format(
                            "yyyy-MM-DD HH:mm:ss",
                          )
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="训练完成情况"
                align="center"
                prop="drillPerformance"
              >
              </el-table-column>
              <el-table-column label="总结说明" align="center" prop="remark">
                <template slot-scope="scope">
                  <div class="elpss2">{{ scope.row.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="主观疲劳感(1-10级)"
                align="center"
                prop="fatigue"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.fatigue + "级" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="总结人" align="center" prop="createBy">
              </el-table-column>
              <el-table-column
                label="总结时间"
                align="center"
                prop="createTime"
                width="180"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.createTime
                        ? moment(scope.row.createTime).format(
                            "yyyy-MM-DD HH:mm:ss",
                          )
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                  <div class="">
                    <el-button
                      size="small"
                      plain
                      type="primary"
                      @click="operation('edit', scope.row)"
                      v-if="scope.row.editAndDelStatus == 1"
                      >编辑</el-button
                    >

                    <a-popconfirm
                      title="确定删除吗？该操作不会撤销"
                      ok-text="是"
                      cancel-text="否"
                      @confirm="sumDele('delete', scope.row)"
                      v-if="scope.row.editAndDelStatus == 1"
                    >
                      <el-button size="small" plain type="danger"
                        >删除</el-button
                      >
                    </a-popconfirm>
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
            <pagination
              :total="total_zjsm"
              :page.sync="pageNum"
              :limit.sync="pageSize"
            />
          </el-card>
        </div>
      </div>
      <!-- 周-end -->
      <!------------ 切换的内容区域-end ------------>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/zh-cn";
import * as API_Member from "@/api/member/member";
import * as echarts from "echarts";
import { DaylastTime, timestampToTime, everyTime } from "./index";
let myChart1;
let myChart2;
export default {
  inject: ["getId"],
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: "时段",
          dataIndex: "drillTimeFrame",
          slots: { customRender: "drillTimeFrame" },
        },
        {
          title: "训练日期",
          dataIndex: "trainingTime",
          customRender: function (val) {
            let value = val.text;
            return moment(value).format("YYYY-MM-DD");
          },
        },
        {
          title: "训练完成情况",
          dataIndex: "drillPerformance",
          key: "drillPerformance",
        },
        {
          title: "总结说明",
          dataIndex: "remark",
          key: "remark",
          slots: { customRender: "remark" },
        },
        {
          title: "主观疲劳感(1-10级)",
          dataIndex: "fatigue",
          slots: { customRender: "fatigue" },
        },
        {
          title: "总结人",
          dataIndex: "createBy",
          key: "createBy",
        },
        {
          title: "总结时间",
          dataIndex: "createTime",
          customRender: function (val) {
            console.log(val);
            let value = val.text;
            return moment(value).format("YYYY-MM-DD HH:mm:ss");
          },
        },
        {
          title: "操作",
          dataIndex: "tags",
          key: "tags",
          width: 200,
          align: "center",
          slots: { customRender: "tags", action: "tags" },
        },
      ],
      columns_zjsm: [
        {
          title: "训练日期",
          dataIndex: "trainingTime",
          customRender: function (val) {
            let value = val.text;
            return moment(value).format("YYYY-MM-DD");
          },
        },
        {
          title: "训练完成情况",
          dataIndex: "drillPerformance",
        },
        {
          title: "总结说明",
          dataIndex: "remark",
          key: "remark",
          slots: { customRender: "remark" },
        },
        {
          title: "主观疲劳感(1-10级)",
          dataIndex: "fatigue",
          slots: { customRender: "fatigue" },
        },
        {
          title: "总结人",
          dataIndex: "createBy",
          key: " createBy",
        },
        {
          title: "总结时间",
          dataIndex: "createTime",
          customRender: function (val) {
            let value = val.text;
            return moment(value).format("YYYY-MM-DD HH:mm:ss");
          },
        },
        {
          title: "操作",
          dataIndex: "tags",
          key: "tags",
          width: 200,
          align: "center",
          slots: { customRender: "tags", action: "tags" },
        },
      ],
      memberList: [],
      memberActive: 0,
      dateTab: 1,
      // memberId: null,

      week: moment(),
      month: moment(),
      date: moment(),
      dataTableInfoVo: {},
      sportList: [],
      selectDate: 0,
      day: new Date(),
      data_wcqk: {}, //完成情况
      data_ydyzj: {}, //运动员总结主观疲劳感
      data_jlyzj: {}, //教练员总结主观疲劳感
      data_zjsm: [], //总结说明
      total_zjsm: 0,
      pageNum: 1,
      pageSize: 10,
      shows: false,
      createTime: null,
      queryValue: null,
      startTime: null,
      endTime: null,
      // userType: this.$store.state.loginInfo.type, //用户类型
      monthFormat: "YYYY/MM",
    };
  },
  created() {},
  computed: {
    id() {
      return this.getId();
    },
  },
  mounted() {
    this.changeBtnlLists();
  },
  methods: {
    //////////////////// 切换日-周-月-全局-start
    moment(v) {
      return moment(v);
    },
    // 改变周
    onChange(weekData) {
      this.week = weekData;
      this.getList({
        startTime: this.moment(weekData)
          .isoWeekday(1)
          .startOf("day")
          .day(1)
          .valueOf(),
        endTime: this.moment(weekData)
          .isoWeekday(1)
          .endOf("day")
          .day(7)
          .valueOf(),
      });
    },
    // 改变月
    onChange1(weekData) {
      this.month = weekData;
      // this.startDate = moment(weekData).startOf("month").valueOf();
      this.getList({
        queryValue: "3",
        month: this.moment(weekData).format("YYYY-MM"),
      });
    },
    // 改变日
    onChange2(weekData) {
      console.log(weekData, "日");
      this.date = weekData;
      // const startDate = (this.startDate = moment(weekData).day(1).valueOf()); // 周一日期
      // const endDate = (this.endDate = moment(weekData).day(7).valueOf()); // 周日日期
      this.getList({
        createTime: everyTime(new Date(weekData).getTime(), "00:00:00", "/"),
      });
    },
    // 切换月周日
    changeData(data) {
      this.selectDate = data;
      this.pageNum = 1;
      this.changeBtnlLists();
    },
    changeBtnlLists() {
      this.types = this.selectDate + 1;
      if (this.types === 1) {
        this.getList({
          createTime: everyTime(
            new Date(this.date ? this.date : "").getTime(),
            "00:00:00",
            "/",
          ),
        });
      } else if (this.types === 2) {
        this.getList({
          startTime: this.moment(this.week ? this.week : "")
            .isoWeekday(1)
            .startOf("day")
            .day(1)
            .valueOf(),
          endTime: this.moment(this.week ? this.week : "")
            .isoWeekday(1)
            .endOf("day")
            .day(7)
            .valueOf(),
        });
      } else {
        this.getList({
          queryValue: "3",
          month: this.moment(this.month ? this.month : "").format("YYYY-MM"),
        });
      }
    },
    //////////////////// 切换日-周-月-全局-end

    // 柱状图-start
    eChartsInit() {
      var chartDom1 = document.getElementById("echartsDom1");
      var chartDom2 = document.getElementById("echartsDom2");
      myChart1 = echarts.init(chartDom1);
      myChart2 = echarts.init(chartDom2);
    },

    setOption(id, { time, list }) {
      console.log("setOption");
      console.log(time, "time");
      console.log(list, "list");
      const color = ["#38A0FF", "#4CCA73", "#F9D337", "#415088", "#F59A23"];
      var app = {};
      var option;
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90,
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right",
          },
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom",
          },
        },
        position: {},
        distance: {
          min: 10,
          max: 10,
        },
      };
      app.config = {
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 10,
        onChange: function () {
          const labelOption = {
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            distance: app.config.distance,
          };
          this.myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                type: "solid",
                color: "#e1e1e1",
                width: 2,
              },
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              color: "#aaa",
              interval: 0,
              formatter: function (value) {
                // if (value.length > 3) {
                //   return value.slice(0, 3) + "...";
                // }
                return value;
              },
            },
            data: time,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#999",
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#999",
              },
            },
            min: 0,
            max: 10,
            // interval: 1,
          },
        ],
        grid: {
          left: "30px",
          right: "0",
          top: "20px",
          bototm: "0",
        },
        legend: {
          bottom: "0%",
          left: "center",
          textStyle: {
            color: "#fff",
          },
        },
        series: list.map((item, index) => {
          return {
            type: "bar",
            name: item.name,
            data: item.data,
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: color[index],
            },
            barWidth: "20px",
            barGap: 0,
          };
        }),
      };
      option && id.setOption(option);
    },
    // 柱状图-end

    moment,
    getCurrentData() {
      return new Date().toLocaleDateString();
    },

    //table 操作列
    sumDele(type, record) {
      console.log(record);
      let param = {};
      let url = "";
      url = "/sys/summary/del";
      param = {
        ids: [record.id],
      };
      this.$axios.post(url, param, true).then((res) => {
        if (res.code == 0 || res.code == 200) {
          this.changeBtnlLists();
        }
      });
    },

    // 格式化日期时间
    changeTime() {
      return function (time, type) {
        type = type ? type : "YYYY-MM-DD HH:mm:ss";
        if (type == "week") {
          let num = moment(time).weekday();
          num =
            num == 0
              ? "周一"
              : num == 1
                ? "周二"
                : num == 2
                  ? "周三"
                  : num == 3
                    ? "周四"
                    : num == 4
                      ? "周五"
                      : num == 5
                        ? "周六"
                        : "周日";
          return num;
        } else {
          return moment(time).format(type);
        }
      };
    },

    getList(obj) {
      let params = {};
      this.data_zjsm = [];
      console.log(this.selectDate);
      if (this.selectDate == 0) {
        params = {
          startTime: obj.createTime,
          userId: this.id,
        };
        console.log(obj);
        this.dataSource = [];
        API_Member.getPcDayTrainingSummaryData(params).then((res) => {
          this.dataSource = res.data;
        });
      } else {
        if (this.selectDate == 1) {
          params = {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            startTime: obj.startTime,
            endTime: obj.endTime,
            // startTime: 1691942400000,
            // endTime: 1692547199999,
            userId: this.id,
          };
        } else if (this.selectDate == 2) {
          params = {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            month: obj.month,
            userId: this.id,
          };
        }
        API_Member.getPcTrainingSummaryWeekAndMonthData(params).then((res) => {
          let datas = res.data;
          this.data_wcqk = datas.trainingSummaryPerformance; //完成情况
          this.data_ydyzj = datas.sportsManFatigue; //运动员总结主观疲劳感
          this.data_jlyzj = datas.trainerFatigue; //教练员总结主观疲劳感
          this.data_zjsm = datas.pcTsTableList.list;
          this.total_zjsm = datas.pcTsTableList.total;
          this.eChartsInit();
          this.setOption(myChart1, datas.sportsManFatigue.tableData);
          this.setOption(myChart2, datas.trainerFatigue.tableData);
        });
      }
    },
    changePage(e) {
      this.getList();
    },
    // 添加训练计划
    operation(type, record) {
      let params = {};
      if (type == "edit") {
        params = {
          id: record.id,
        };
        this.$router.push({
          path: "/sum/add",
          query: params,
        });
      } else if (type == "add") {
        this.$router.push({
          path: "/sum/add",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.elpss2 {
  max-width: 400px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.controlBox {
  padding: 20px;

  .controlHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    border-left: 5px solid #1890ff;
    padding-left: 10px;
    font-weight: bold;
    color: #fff;
  }

  .control {
    // width: 100%;
    display: flex;
    align-items: center;
    justify-content: right;

    .addBtn {
      height: 36px;
      margin-left: 20px;
    }

    .tab {
      margin-left: 20px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        font-size: 18px;
        padding: 2px 20px;
        color: #ccc;
        border: 1px solid #ccc;
        position: relative;
      }

      div:nth-child(2) {
        padding: 2px 24px;
        margin-left: -1px;
        margin-right: -1px;
      }

      div:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      div:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      .active {
        color: #1890ff;
        border-color: #1890ff;
        z-index: 2;
      }
    }
  }

  .tabCon {
    margin-top: 20px;
    // border: 1px solid #fff;
  }
}

::v-deep.ant-calendar-picker-input.ant-input {
  height: 36px;
}

.week {
  .box {
    margin-top: 20px;
    margin-bottom: 20px;
    display: inline-block;
    width: 100%;
    .minTitle {
      font-size: 15px;
      margin-bottom: 8px;
    }

    .minTitleInfo {
      font-size: 12px;
      font-weight: normal;
      color: rgba(255, 255, 255, .5);

      b {
        color: #fff;
      }

      span {
        margin-right: 20px;
      }
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .block {
        width: 380px;
        text-align: center;
        padding: 30px;
        color: #fff;
        background-color: #21284B;

        strong {
          width: 100%;
          display: inline-block;
          font-weight: bold;
          font-size: 16px;
          margin-top: 5px;
        }
      }

      .item {
        flex: 1;
        height: 142px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: #21284B;
        margin-right: 20px;

        .count {
          margin-bottom: 12px;
          font-size: 16px;
        }
        .num {
          font-weight: bold;
          font-size: 20px;
        }
      }
    }
    .item:last-child {
      margin-right: 0;
    }

    .figure {
      height: 380px;
      padding: 10px 0 20px 0;
    }
  }
}
.boxCard{
  border: 1px solid rgba(255, 255, 255, .1);
}
</style>
